// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__4rzXr","ranges":"BmiRanges_ranges__nTHM_"};